import {route, string} from 'react-router-typesafe-routes';

export const yourSpaceRoutesPath = route({
  children: {
    contacts: route({
      path: 'contacts',
    }),
    finances: route({
      path: 'my-finances',
    }),
    joinedPrograms: route({
      path: 'my-joined-programs',
    }),
    library: route({
      path: 'my-library/:folderId?',
      searchParams: {
        id: string(),
        mid: string(),
        pid: string(),
        sid: string(),
      },
    }),
    myCoaches: route({
      path: 'my-coaches',
    }),
    notes: route({
      path: 'my-notes',
    }),
    practice: route({
      path: 'practice',
    }),
    routine: route({
      path: 'routine',
    }),
    services: route({
      path: 'my-services',
    }),
    sessionNotes: route({
      path: 'my-notes',
    }),
    toolbox: route({
      children: {
        assessment: route({
          path: ':assessmentId',
        }),
        trackers: route({
          path: 'trackers',
        }),
      },
      path: 'my-toolbox',
    }),
  },
  path: 'your-space',
});
